import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/23a84628/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Tabs`}</h2>
    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/tabs--default",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-tabs--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvtabs--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=tabs"
    }} knobs={{
      Tab: ["disabled", "selected"]
    }} mdxType="ComponentDemo">
  {`
<div style={{ width: '50%'}}>
  <Tabs>
    <Tab
      href="#"
      id="tab-1"
      label="Tab label 1"
    >
      <div className="some-content">
        Content for first tab goes here.
      </div>
    </Tab>
    <Tab
      href="#"
      id="tab-2"
      label="Tab label 2"
    >
      <div className="some-content">
        Content for second tab goes here.
      </div>
    </Tab>
    <Tab
      href="#"
      id="tab-3"
      label='Tab label 3'
    >
      <div className="some-content">
        Content for third tab goes here.
      </div>
    </Tab>
  </Tabs>
</div>
  `}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      